module.exports = __webpack_public_path__ + "img/logo_com_fundo.d6cb922f.svg";